import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useProductList(params) {
  return useSWR(
    {
      path: `/api/v1/products`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProductList;
